export default "__VITE_PUBLIC_ASSET__f37f2c14__"